"use client";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar";
import { getInitial } from "../../helper/utility";

interface PageHeaderProps {
  logo: string;
  name: string;
  description: string;
}

export function PageHeader({ logo, name, description }: PageHeaderProps) {
  return (
    <div className="text-center mb-8">
      <div className="flex justify-center mb-4">
        <Avatar className="w-20 h-20">
          <AvatarImage src={logo} alt={name} width={64} height={64} />
          <AvatarFallback>{getInitial(name)}</AvatarFallback>
        </Avatar>
      </div>
      <h1 className="text-3xl font-bold text-foreground mb-2">{name}</h1>
      <div className="max-w-4xl mx-auto">
        <p className="text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}
